import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { map, switchMap, take, catchError, filter } from 'rxjs/operators';
import { of } from 'rxjs';
import { selectAdminGuardData } from '../store/auth/auth.selectors';
import { UserService } from '../services/user.service';
import { UserRole } from '../models/user.interface';
import { userNeedsProfileCompletion } from '../utils/user-needs-profile-completion';

/**
 * Guard Admin - Verifica autenticazione e ruolo ADMIN
 * Sul server SSR passa sempre (Firebase Auth funziona solo nel browser)
 */
export const adminGuard: CanActivateFn = (route, state) => {
  const platformId = inject(PLATFORM_ID);
  const store = inject(Store);
  const router = inject(Router);
  const userService = inject(UserService);

  // SSR: Passa sempre la guard (il browser farà il controllo reale)
  if (!isPlatformBrowser(platformId)) {
    return of(true);
  }

  return store.select(selectAdminGuardData).pipe(
    // Aspetta che Firebase sia inizializzato E che i dati backend siano caricati (se necessario)
    filter(authData => authData.isInitialized && !authData.isLoading),
    take(1),
    switchMap(authData => {
      // Non autenticato -> login
      if (!authData.isAuthenticated || !authData.user) {
        router.navigate(['/login']);
        return of(false);
      }

      if (userNeedsProfileCompletion(authData.user)) {
        router.navigate(['/completa-registrazione']);
        return of(false);
      }

      // Verifica ruolo ADMIN
      if (authData.role !== UserRole.ADMIN) {
        router.navigate(['/']);
        return of(false);
      }
      
      return of(true);
    })
  );
};
